import React, { useState } from 'react'
import { TabbedPage, Tab } from 'components/Shared/TabbedPage'
import FieldFormsSettings from 'components/ProjectConfiguration/FieldFormsSettings'
import AddFieldForm from 'components/ProjectConfiguration/AddFieldForm'
import { FormProvider } from 'context/FormContext';

const tabs = [
    new Tab({ label: "Settings", value: "FieldFormsSettings" }),
    new Tab({ label: "Add Field Form", value: "AddFieldForm", scope: "ProjectConfig", action: "create" }),
]

const FieldFormSettingsTabs = () => {
    const [activeTab, setActiveTab] = useState("FieldFormsSettings")
    return (
        <FormProvider>
          <div  style={{paddingTop: '20px'}}>
            <TabbedPage
                tabs={tabs}
                activeTab={activeTab}
                tabSetterFunc={setActiveTab}
                elevation={0}
            >
                {(() => {
                    switch (activeTab) {
                        case "FieldFormsSettings": return <FieldFormsSettings  callback={() => {setActiveTab("FieldFormsSettings")}}/>
                        case "AddFieldForm": return <AddFieldForm   callback={() => {setActiveTab("FieldFormsSettings")}} />
                        default: return <FieldFormsSettings />
                    }
                })()}
            </TabbedPage>
            </div>
        </FormProvider>
    )
}

export default FieldFormSettingsTabs